
import { Component, Vue } from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import AdminSkinCell from "@/components/admin/AdminSkinCell.vue";
import gql from "graphql-tag";
import * as _ from "lodash";
import { fetchSteamItems, SteamItemLookup } from "@/helpers/admin-steam-items";

@Component({
  components: {
    AdminTable,
    AdminSkinCell
  },
  apollo: {
    partners: {
      query: gql`
        query {
          getAllPartners {
            _id
            name
            avatar
          }
        }
      `,
      fetchPolicy: "no-cache",
      update(data) {
        if (data && data.getAllPartners) {
          const index = this.columns.findIndex(
            ({ field }) => field === "partnerUserIds"
          );
          this.partners = data.getAllPartners;
          this.columns[index].enum = data.getAllPartners;
        }
        return data && data.getAllPartners ? data.getAllPartners : [];
      }
    }
  }
})
export default class AdminSteamBotItem extends Vue {
  async updateModelDoc(_id: string, updatedFields: any, unsetFields?: any) {
    return this.$apollo.mutate({
      mutation: gql`
        mutation updateModelDoc(
          $_id: ID!
          $updatedFields: JSON!
          $unsetFields: JSON
          $modelName: String!
        ) {
          updateModelDoc(
            _id: $_id
            updatedFields: $updatedFields
            modelName: $modelName
            unsetFields: $unsetFields
          )
        }
      `,
      // Parameters
      variables: {
        _id,
        updatedFields,
        unsetFields,
        modelName: "steamBotItemModel"
      }
    });
  }

  async setPartners() {
    this.setPartnersLoading = true;
    for await (const item of this.selectedItems) {
      try {
        await this.updateModelDoc(item._id, {
          partnerUserIds: this.selectedPartners
        });
        item.partnerUserIds = this.selectedPartners;
      } catch (e) {
        this.$q.notify({
          type: `negative`,
          message: `${item._id}: ${e.message}`
        });
      }
    }
    this.setPartnersLoading = false;
    this.selectedPartners = [];
    this.partnersDialog = false;
  }

  partners: any = [];
  selectedItems: any = [];
  partnersDialog = false;
  setPartnersLoading = false;
  selectedPartners: any = [];
  // steamItemId → { image, rarityColor }; null — скина нет в базе
  steamItems: Record<string, SteamItemLookup | null> = {};
  columns = [
    {
      name: "_id",
      required: true,
      label: "name",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      name: "steamBotId",
      required: true,
      label: "steamBotId",
      field: "steamBotId",
      align: "left",
      type: "string",
      editable: true
    },
    {
      name: "steamItemId",
      align: "center",
      label: "steamItemId",
      field: "steamItemId",
      editable: true,
      type: "string"
    },
    /*{
      // Ключ SteamItem для цены: "<steamItemId> - <phase>" для доплера
      name: "priceItemId",
      align: "center",
      label: "priceItemId",
      field: "priceItemId",
      type: "string"
    },*/
    {
      name: "phase",
      align: "center",
      label: "phase",
      field: "phase",
      type: "string"
    },
    {
      name: "paintIndex",
      align: "center",
      label: "paintIndex",
      field: "paintIndex",
      type: "number"
    },
    {
      name: "state",
      align: "center",
      label: "state",
      field: "state",
      editable: true,
      type: "string",
      enum: ["DEFAULT", "RESERVED", "WITHDRAWN"]
    },
    {
      name: "appId",
      align: "center",
      label: "appId",
      field: "appId",
      type: "number"
    },
    {
      name: "float",
      align: "center",
      label: "float",
      field: "float",
      type: "number"
    },
    {
      name: "tradableAfter",
      align: "center",
      label: "tradableAfter",
      field: "tradableAfter",
      editable: true,
      type: "string"
    },
    {
      name: "partnerUserIds",
      align: "center",
      label: "partnerUserIds",
      field: "partnerUserIds",
      editable: true,
      optionLabel: "name",
      optionValue: `_id`,
      type: "array",
      enum: []
    },
    {
      name: "assetId",
      align: "center",
      label: "assetId",
      field: "assetId",
      editable: true,
      type: "string"
    }
  ];

  // Картинки и редкость скинов текущей страницы — одним запросом
  async loadSteamItems(docs: any[]) {
    const names = _.uniq(
      (docs || []).map(doc => doc.steamItemId).filter(Boolean)
    ).filter(name => !(name in this.steamItems));

    if (!names.length) {
      return;
    }

    try {
      this.steamItems = {
        ...this.steamItems,
        ...(await fetchSteamItems(this.$apollo, names))
      };
    } catch (error) {
      this.$q.notify({
        message: `Не удалось загрузить картинки скинов: ${error.message}`,
        multiLine: true,
        type: "negative"
      });
    }
  }
}
